// @flow
import React, { Component, Fragment } from 'react'; 
import Card from './Card/Card';
import classNames from 'classnames/bind';
import {Desktop, UntilTablet} from '../../../../utils/responsive';
import Slider from 'react-slick/lib';

import watchingLaptop from '../../../../assets/img/home/featured-cards/watching-laptop.png';
import circleBackground from '../../../../assets/img/home/featured-cards/circle-background.png';
import iconPeru from '../../../../assets/img/home/featured-cards/icons/icon-peru.png';
import iconTools from '../../../../assets/img/home/featured-cards/icons/icon-tools.png';
import iconCard from '../../../../assets/img/home/featured-cards/icons/icon-card.png';
import iconCoupon from '../../../../assets/img/home/featured-cards/icons/icon-coupon.png';
import iconWarranty from '../../../../assets/img/home/featured-cards/icons/icon-warranty.png';
import iconStore from '../../../../assets/img/home/featured-cards/icons/icon-store.png';

import style from './FeaturesCards.scss';
 
type Props = {  
};

type State = {  
};

const listCard = [
  {
      title: '1 Millón de tiendas',
      textBody: 'Más de un millón de tiendas diponibles para tus compras',
      icon : iconStore, 
  },
  {
      title: 'Hasta 80% OFF',
      textBody: 'Las mejores ofertas de las tiendas de USA están a tu alcance con Qempo', 
      icon : iconCoupon, 
  },
  {
      title: 'Llegamos a todo el Perú',
      textBody: 'Olvídate de gastos sorpresas. Tu pedido irá directamente a tu dirección en Perú',
      icon : iconPeru
  },
  {
      title: 'Cuotas sin intereses',
      // textBody: 'Paga en 3 cuotas sin intereses con tarjetas BCP y hasta en 3 cuotas sin intereses con tarjetas Diners y VISA BBVA',  
      textBody: 'Paga en 3 cuotas sin intereses con tarjetas Diners y VISA BBVA',  
      icon : iconCard
  },
  {
      title: 'Garantía Gratis',
      textBody: 'Somos los únicos que te damos garantía de 90 días totalmente GRATIS', 
      icon : iconWarranty
  },
  {
      title: 'Sin Trámites',
      textBody: 'Olvídate de trámites y papeleos, Qempo se encargará de todo',
      icon : iconTools
  } 
];

export default class FeaturedCards extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = { 
    };
  } 

  render() {  

    const slidesToShow = 3;
    
    const settings = {
      dots: true,
      infinite: true,
      arrows: false,
      vertical: true,
      draggable: true,
      speed: 1000,
      autoplay: true,
      verticalSwiping: true,
      autoplaySpeed: 8000,
      slidesToShow: slidesToShow,
      slidesToScroll: 3,
      dotsClass: classNames('slick-dots', style.dots),
    };

    const cards = (
      <div className={style.cardsWrap}>
        <Desktop>
          <div className={style.contentWrap}> 
            {listCard.slice(0,3).map((item, index: number)=> (
              <div className={style.column} key={`card-${index}`} style={index === 1 ? {marginTop: '40px'} : {}} >
                <Card
                  className={style.card}
                  title={item.title}
                  textBody={item.textBody}  
                  icon = {item.icon}
                />
                <Card
                  className={style.card}
                  title={listCard[index + 3].title}
                  textBody={listCard[index + 3].textBody}  
                  icon = {listCard[index + 3].icon}
                />
              </div>
            ))}  
          </div> 
            
        </Desktop>
        <UntilTablet>
          <Slider {...settings}>
            {listCard.map((item, index: number)=> (
              <div key={`card-${index}`} >
                <Card
                  title={item.title}
                  textBody={item.textBody}  
                  icon = {item.icon}
                />
              </div>
            ))}
          </Slider>
         
        </UntilTablet>
      </div>
    );

    const watchingLaptopSection = (
      <div className={style.imageWrap} style={{background: `url(${circleBackground}) no-repeat center`}}>
        <img className={style.watchingLaptop} src={watchingLaptop} alt="watching-laptop" />
      </div>
    );

    return (  
        <section className={style.featuresCardWrap}>
            <div className={style.featuresCardContent}>
                <div className={style.leftWrap}>
                  <div className={style.contentWrap}>
                    <div className={style.textWrap}>
                      <h1 className={style.title}>
                        ¡Sumarte valor es nuestra tarea principal!
                      </h1>
                      <span className={style.subtitle}>
                        Día a día trabajamos en sumar nuevos beneficios para que tus compras en el mundo sean existosas
                      </span>
                    </div>
                    <Desktop>
                    {watchingLaptopSection}
                  </Desktop>
                  </div>
                </div>

                <div className={style.rightWrap}>
                  {cards}
                  <UntilTablet>
                    {watchingLaptopSection}
                  </UntilTablet>
                </div>
            </div>
        </section>
    );
  }
}


FeaturedCards.propTypes = { 
};
 



// WEBPACK FOOTER //
// ./src/modules/home/elements/FeaturesCards/FeaturesCards.jsx